import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_linear, {
            class: "mx-2",
            color: "primary",
            indeterminate: ""
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.attendance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_breadcrumbs, {
              class: "px-0",
              items: _ctx.breadcrumbsItems,
              color: "primary"
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.dateString) + " : " + _toDisplayString(_ctx.attendance.nurseryUser.lastName) + _toDisplayString(_ctx.attendance.nurseryUser.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", null, "Clock In Time", -1)),
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              type: "time",
              modelValue: _ctx.attendedAt,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attendedAt) = $event)),
              readonly: !_ctx.canEditAttendance,
              disabled: !_ctx.canEditAttendance
            }, null, 8, ["modelValue", "readonly", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("div", null, "Clock Out Time", -1)),
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              type: "time",
              modelValue: _ctx.leftAt,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftAt) = $event)),
              readonly: !_ctx.canEditAttendance,
              disabled: !_ctx.canEditAttendance
            }, null, 8, ["modelValue", "readonly", "disabled"])
          ]),
          (_ctx.canEditAttendance)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    "x-large": "",
                    disabled: _ctx.isSaving,
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canEditAttendance)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                justify: "center",
                class: "pt-10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.deleteAttendance,
                    disabled: _ctx.isSaving,
                    color: "error",
                    variant: "outlined",
                    "x-large": ""
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Delete Clock In/Out", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_ctx.isSaving)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}